import { createAsyncThunk } from "@reduxjs/toolkit";
import { PostVouchersPromocodeUnassignParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const postVouchersPromocodeUnassign = createAsyncThunk<
  void,
  PostVouchersPromocodeUnassignParams
>(
  "vouchers/postVouchersPromocodeUnassign",
  async (params, { rejectWithValue }) => {
    try {
      await VouchersAPI.postVouchersPromocodeUnassign(params);
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while unassigning promocode",
          error.response?.data
        );
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error("Error while unassigning promocode", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
